import router from '../router'
import store from '../store'

export const mutations = {
  login (state, payload) {
    state.userState = payload
    state.loginState = false
  },
  logout (state) {
    state.userState = {}
    state.loginState = true
    state.userLogged = {}
  },
  onRequestChangePassword (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    setTimeout(function () {
      router.replace('/auth/login')
    }, 2000)
  },
  onChangePassword (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    setTimeout(function () {
      router.replace('/auth/login')
    }, 2000)
  },
  onChangePass (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.close()
  },
  onGetCountry (state, payload) {
    const items = payload.response.data.data.data
    const foundMexico = items.find(e => e.id === 150)
    const foundUsa = items.find(e => e.id === 65)
    const list = items.filter(e => e.id !== 150 && e.id !== 65)
    list.unshift(foundMexico, foundUsa)
    payload.event.context.countries = list
  },
  onGetFiscal (state, payload) {
    payload.event.context.fiscal = payload.response.data.data
  },
  onGetFile (state, payload) {
    payload.event.context.file = payload.response.data.data
    if(payload.event.context.showImage  === 'function') payload.event.context.showImage()
  },
  onUserLogged (state, payload) {
    store.state.userLogged = payload.response.data.data
    store.state.userLogged.allPermissions = []
    store.state.userLogged.roles[0].permissions.map(item => {
      store.state.userLogged.allPermissions.push(item.name)
    })
    store.state.userLogged.permissions.forEach(item => {
      store.state.userLogged.allPermissions.push(item.name)
    })
  },
  onChangeLanguage (state, payload) {
    payload.event.context.showNotification(payload.response, 'success')
    payload.event.context.userLogged.lang = payload.event.data.language
  },
  onGetContacts(state, payload) {
    payload.event.context.contacts = payload.response.data.data.data
    if (payload.event.context.options) {
      payload.event.context.options.itemsPerPage = parseInt(payload.response.data.data.per_page)
      payload.event.context.options.page = payload.response.data.data.current_page
      payload.event.context.options.total = payload.response.data.data.total
    }
    payload.event.context.loadTable = false
  },
  /** Se obtiene la respuesta de la peticion para zonas horarias, almacenandola en un array y creando su ordenamiento alfabeticamente */
  onGetTimeZone (state, payload) {
    let data = payload.response.data.data.data
    let array = []
    for (let item in data) {
      array.push(data[item])
    }
    array.sort((a, b) => a.label.localeCompare(b.label))
    payload.event.context.timezones = array
  },
  onDeleteContact (state, payload) {
    payload.event.context.showNotification(payload.response.data.message, 'success')
    payload.event.context.close()
    payload.event.context.get()
  },
  onErrorLogged (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    store.dispatch('logout', {event: {context: payload.event.context}})
  },
  onErrorPass (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    payload.event.context.showNotification(payload.error.response, 'error', -1)
    payload.event.context.loading = false
  }
}